import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import type {
  AdvertiserBrand,
  ApiResponse,
  CreateBrandRequest,
  UpdateBrandRequest,
} from '@magnetar/admin-api-interfaces'

function failure<T>(code: string, message: string): ApiResponse<T> {
  return { success: false, error: { code, message } } as ApiResponse<T>
}

/** 供應商的品牌管理表（admin 側；與 Portal 同一份資料） */
export const brandService = {
  create: async (supplierId: number, data: CreateBrandRequest, token: string) => {
    try {
      const response = await apiClient.post<ApiResponse<AdvertiserBrand>>(
        `/api/ad-supplier/${supplierId}/brands`,
        data,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) return error.response.data as ApiResponse<AdvertiserBrand>
      return failure<AdvertiserBrand>('CREATE_BRAND_FAILED', '建立品牌失敗')
    }
  },
  update: async (supplierId: number, brandId: number, data: UpdateBrandRequest, token: string) => {
    try {
      const response = await apiClient.put<ApiResponse<AdvertiserBrand>>(
        `/api/ad-supplier/${supplierId}/brands/${brandId}`,
        data,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) return error.response.data as ApiResponse<AdvertiserBrand>
      return failure<AdvertiserBrand>('UPDATE_BRAND_FAILED', '更新品牌失敗')
    }
  },
  remove: async (supplierId: number, brandId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<{ brand_id: number }>>(
        `/api/ad-supplier/${supplierId}/brands/${brandId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) return error.response.data as ApiResponse<{ brand_id: number }>
      return failure<{ brand_id: number }>('DELETE_BRAND_FAILED', '刪除品牌失敗')
    }
  },
}
